import Insurance from "../../services/Insurance"
import { BaseAppConfigs, HttpClient, toast,  AppId,
  Button, FormattedMessage,

  BaseAppUltils } from 'base-app'
import React, { lazy, Suspense } from 'react'
import moment from 'moment'
import InsuranceAppVIew from "../../pages/user-group/InsuaranceApp/InsuranceAppVIew"
import { Formik, FormikProvider } from "formik"
import { useState } from "react"
import { ModalBody } from "reactstrap"
import { history } from "../../history"
import Utils from "../../configs/constants/Utils"
import * as CONST from '../../configs/constants/BuyInsurance'
export const ACTION_CHOOSE = 'ACTION_CHOOSE'
export const ACTION_TOGGLETNDS = 'ACTION_TOGGLETNDS'
export const ACTION_IS_CAl_FEE = 'ACTION_IS_CAl_FEE'
export const ACTION_UPDATE_ACTIVE_STEP = 'ACTION_UPDATE_ACTIVE_STEP'
export const ACTION_IS_LOADING = 'ACTION_IS_LOADING'

export const chooseSelect = (action, data) => {
  return (dispatch) => {
    dispatch({
      type: action,
      payload: data
    })
  }
}

const cbStep = (nameStep, name, res) => {


}
export const checkInfoVehicle = (idNum, formik, arrGetType) => {
  return async (dispatch) => {
    if (formik.values.Step1.numberPlate != "") {
      const res = await Insurance.API_CHECK_NUMBERPLATE(idNum)
      if (res.status == 200) {

        cbStep()
        formik.values.Step1.notFound404 = res.status

        formik.values.Step1.showOrNot = true
        // console.log(formik.values.machineNumber)
        formik.values.machineNumber = res.data.machineNo
        formik.values.frameNumber = res.data.frameNo
        formik.values.TypeVehicle = res.data.vehicleType.name
        formik.values.BrandVehicle = res.data.manufacturerName
        formik.values.LineVehicle = res.data.brandName
        /*--------------------------------------------------*/
        formik.values.Step1.machineNumber = res.data.machineNo
        formik.values.Step1.frameNumber = res.data.frameNo
        formik.values.Step1.TypeVehicle = res.data.vehicleType.name
        formik.values.Step1.BrandVehicle = res.data.manufacturerName
        formik.values.Step1.LineVehicle = res.data.brandName
        formik.values.Step1.id = res.data.contractId;
        formik.setFieldValue();
      }
      else {
        if (res.status == 404) {
          formik.values.Step1.notFound404 = res.status
          // formik.resetForm()
        }
      }
    }

  }
}


export const checkInfoContract = (idNum, formik, step) => {
  // // console.log(formik.values)
  return async (dispatch) => {
    //16k2-0642
    const res = await Insurance.checkInfoContract(idNum)
    if (res.status == 200) {
      formik.values.Step3.errors404 = res.status
      formik.values.Step5.errors404 = res.status
      // console.log(res)

      if (step == 4) {
        if (res.data.icType == CONST.ID_TYPE_CMND || res.data.icType == CONST.ID_TYPE_CCCD || res.data.icType == CONST.ID_TYPE_HOCHIEU) {
          formik.setFieldValue(`Step5.loaiGiayto`, res.data.icType);
          formik.setFieldValue('Step5.getFullNamePers', res.data.fullName)
          formik.setFieldValue('Step5.getPhonePers', res.data.phoneNumber)
          formik.setFieldValue('Step5.getEmailPers', res.data.email)
          formik.setFieldValue('Step5.getAddressPers', res.data.address)
        }
        else {
          formik.setFieldValue('Step5.getNameTc', res.data.fullName)
          formik.setFieldValue('Step5.getPhoneTc', res.data.phoneNumber)
          formik.setFieldValue('Step5.getEmailTc', res.data.email)
          formik.setFieldValue('Step5.getAddressTc', res.data.address)
        }
      }
      else if (step == 2) {
        const resCreate = await Insurance.updateInsurance1(
          {
            "id": formik.values.Step1.id,
            "companyId": formik.values.Step2.companyId,
            "companyName": "BSH",
          }
        )


        if (formik.values.Step3.soGiayToTuyThan != "MST") {
            formik.values.Step3.fullName = res.data.fullName
          formik.values.Step3.gender = res.data.gender
          formik.values.Step3.dateOfBirth = res.data.dateOfBirth
          formik.values.Step3.soGiayToTuyThan1 = res.data.icNo
          formik.values.Step3.Email = res.data.email
          formik.values.Step3.phoneNumber = res.data.phoneNumber
          formik.setFieldValue();
        }
        else {
          formik.values.Step3.errors404 = res.status
          formik.values.Step5.errors404 = res.status
          formik.values.Step3.tenToChuc = res.data.fullName
          formik.values.Step3.ngayCap = res.data.issuedDate
          formik.values.Step3.emailTc = res.data.email
          formik.values.Step3.phoneTc = res.data.phoneNumber
          formik.values.Step3.noiCap = res.data.issuedPlace

          formik.setFieldValue();
        }
      }
    }
    else {
      BaseAppUltils.toastError(<FormattedMessage id={`${AppId.DIVAY_INSURANCE_APP}.InfoNotExistsAlertContent`} />, { autoClose: 1500, })

      if (res.status == 404) {
        formik.values.Step3.errors404 = res.status

        formik.values.Step5.errors404 = res.status
        formik.setFieldValue();
      }
    }
  }
}
export const checkInfoContractStep5 = (idNum, formik) => {
  return async (dispatch) => {
    //16k2-0642
    if (formik.values.Step5.soGiayToTuyThan != "") {
      if (formik.values.Step5.soGiayToTuyThan != "") {
        const res = await Insurance.checkInfoContract(idNum)
        //  // console.log(res)
        if (res.status == 200) {
          if (formik.values.Step5.soGiayToTuyThan != "MST")
            formik.values.Step5.name = res.data.fullName
          formik.values.Step5.PhoneNumber = res.data.phoneNumber
          formik.values.Step5.email = res.data.email
          formik.values.Step5.loaiGiayTo = res.data.icType

          formik.setFieldValue();
        }
      }
    }
    else {
    }
  }
}
//insurances
export const createVehicle = (formik, values) => {
  return async (dispatch) => {
    const contractInfo = formik.values.Step1.id
    if (formik.values.Step1.idVehicle == '') {

      const contractInfo = JSON.stringify({
        contractType: "MC"
      });
      const res = await Insurance.createConstract(contractInfo)
     // // console.log(res)
     //
     // console.log(res.data)


      if (res.status == 200) {
        formik.setFieldValue("contractInfo", res.data)
        formik.values.Step1.id = res.data.id
        formik.values.Step1.IDBHTNDSBB = res.data.insurances[0].id
        formik.values.Step1.IDBHTNDSTN = res.data.insurances[1].id
        const resCreate = await Insurance.createVehicle({
          "numberPlate": formik.values.Step1.numberPlate,
          "vehicleTypeId": formik.values.Step1.TypeVehicleId,
          "manufacturerName": formik.values.Step1.BrandVehicle,
          "brandName": formik.values.Step1.LineVehicle,
          "frameNo": formik.values.Step1.frameNumber,
          "machineNo": formik.values.Step1.machineNumber,
          "contractId": res.data.id
        })
        formik.values.Step1.idVehicle = resCreate.data.id
        formik.setFieldValue('Step1.idMT3orMT2',resCreate.data.vehicleType.id )
        dispatch({
          type: ACTION_UPDATE_ACTIVE_STEP,
          payload: 1
        })
      }
      else{
        dispatch({
          type: ACTION_UPDATE_ACTIVE_STEP,
          payload: 0
        })
      }

    }

    else {

      const updateInsurance = await Insurance.updateVehicle(
        {
          id: formik.values.Step1.idVehicle,
          "numberPlate": formik.values.Step1.numberPlate,
          "vehicleTypeId": formik.values.Step1.TypeVehicleId,
          "manufacturerName": formik.values.Step1.BrandVehicle,
          "brandName": formik.values.Step1.LineVehicle,
          "frameNo": formik.values.Step1.frameNumber,
          "machineNo": formik.values.Step1.machineNumber,
          "contractId": formik.values.Step1.id
        }
      )

      // console.log(updateInsurance)
      //formik.values.Step1.IDBHTNDSBB = res.data.insurances[0].id
      //formik.values.Step1.IDBHTNDSTN = res.data.insurances[1].id
     // // console.log(updateInsurance)
     // formik.values.Step1.IDBHTNDSBB = updateInsurance.data.insurances[0].id
      //formik.values.Step1.IDBHTNDSTN = updateInsurance.data.insurances[1].id
      if(updateInsurance.status ==200)
      {
        formik.setFieldValue('Step1.idMT3orMT2',updateInsurance.data.vehicleType.id )

        formik.values.Step1.idVehicle = updateInsurance.data.id

      }
      else{
        dispatch({
          type: ACTION_UPDATE_ACTIVE_STEP,
          payload: 0
        })
      }

    }
  }
}
export const updateInsurance = (formik, values) => {
  return async (dispatch) => {
    const resCreate = await Insurance.updateInsurance1(
      {
        "id": formik.values.Step1.id,
        "companyId": formik.values.Step2.companyId,
        "companyName": "BSH",
      }
    )
    if(resCreate.status ==200)
    {
      dispatch({
        type: ACTION_UPDATE_ACTIVE_STEP,
        payload: 2
      })
    }
    else{
      dispatch({
        type: ACTION_UPDATE_ACTIVE_STEP,
        payload: 1
      })
    }
  }
}

export const createContact = (formik, values) => {
  return async (dispatch) => {
    if (formik.values.Step3.soGiayToTuyThan == "MST") {
      const resCreateContact = await Insurance.createContact(
        {
          "icType": formik.values.Step3.soGiayToTuyThan,
          "icNo": formik.values.Step3.maSoThue,
          "issuedDate": formik.values.Step3.ngayCap,
          "issuedPlace": formik.values.Step3.noiCap,
          "fullName": formik.values.Step3.tenToChuc,
          "branchName": null,
          "phoneNumber": formik.values.Step3.phoneTc,
          "email": formik.values.Step3.emailTc,
          "address": formik.values.Step3.getAddressRecevierPers,
          "type": "ORG",

          "addresses": [
            {
                "type": "HOME",
                "city": formik.values.Step3.getCityRecevierPers,
                "district": formik.values.Step3.getDistrictRecevierPers,
                "ward": formik.values.Step3.getWardsRecevierPers,
                "detail": formik.values.Step3.getAddressRecevierPers,
            }
        ],

        }
      )
      if(resCreateContact.status == 200)
      {

        const resUpdate = await Insurance.updateInsurance1({
          "id": formik.values.Step1.id,
          "ownerId": resCreateContact.data.id
        })
        formik.setFieldValue('Step4.contractID', resCreateContact.data.id)
        formik.values.Step4.contractID = resCreateContact.data.id
        const getContact = await Insurance.getContact(resCreateContact.data.id)
        const getContractInfo = await Insurance.getContractInfo(formik.values.Step1.id)
        const getFee = await Insurance.getFee(formik.values.Step1.id)

        // // console.log(getContractInfo)
        if (getContractInfo.status == 200) {
          // console.log(getContractInfo)
          const today = new Date()
          const time = today.getHours() + ':' + today.getMinutes()
          formik.setFieldValue('Step4.contractCode', getContractInfo.data.contractCode);
          formik.setFieldValue('Step4.getFullname', getContractInfo.data.customerName);
           formik.setFieldValue('Step4.Fee1', (getContractInfo.data.totalFee));
          //formik.setFieldValue('Step4.Fee1', (getContractInfo.data.totalFeeInclVAT));
          formik.setFieldValue('Step4.Fee2',(getContractInfo.data.vatfee));
          formik.setFieldValue('Step4.Fee3', (getContractInfo.data.totalFeeInclVAT));
          formik.setFieldValue('Step4.dateOfBirth', (getContractInfo.data.owner.dateOfBirth));
          formik.setFieldValue('Step4.getGender', getContractInfo.data.owner.gender);
          formik.setFieldValue('Step4.getEmail', getContractInfo.data.owner.email);
          formik.setFieldValue('Step4.phoneNumber', getContractInfo.data.owner.phoneNumber);
          formik.setFieldValue('Step4.feeTNDS', (getContractInfo.data.insurances[0].fee));
          // formik.setFieldValue('Step4.feeTNDSTNXM', (getContractInfo.data.insurances[1].fee));
         // formik.setFieldValue('Step4.feeTNDS', Utils.formatCurrency(getFee.data[0].MOTOR_TNDS));
         formik.setFieldValue('Step4.feeTNDSTNXM', (getContractInfo.data.insurances[1].fee));
         formik.setFieldValue('Step4.getBrand', getContractInfo.data.vehicles[0].manufacturerName);
          formik.setFieldValue('Step4.getFrame', getContractInfo.data.vehicles[0].frameNo);
          formik.setFieldValue('Step4.getMachine', getContractInfo.data.vehicles[0].machineNo);
          formik.setFieldValue('Step4.getTypeVehicle', getContractInfo.data.vehicles[0].vehicleType.name);
          formik.setFieldValue('Step4.getNumberPlate', getContractInfo.data.vehicles[0].numberPlate);
          formik.setFieldValue('Step4.dongXe', getContractInfo.data.vehicles[0].brandName);
          formik.setFieldValue('Step4.getValueDateStart', getContractInfo.data.insurances[0].startValueDate);
          formik.setFieldValue('Step4.getValueDateEnd', getContractInfo.data.insurances[0].endValueDate);
          formik.setFieldValue('Step4.noiCap', getContractInfo.data.owner.issuedPlace);
          formik.setFieldValue('Step4.getATMFee', getContractInfo.data.atmPayFee);
          formik.setFieldValue('Step4.getQRFee', getContractInfo.data.qrPayFee);
          formik.setFieldValue('Step4.getFunTransferPayFee', getContractInfo.data.funTransferPayFee);
          formik.setFieldValue('Step4.getShipingFee', getContractInfo.data.shipingFee);
          formik.setFieldValue('Step4.getVisaFee', getContractInfo.data.visaMasterPayFee);

          formik.setFieldValue();

        }
        dispatch({
          type: ACTION_UPDATE_ACTIVE_STEP,
          payload: 3
        })
      }
      else{
        dispatch({
          type: ACTION_UPDATE_ACTIVE_STEP,
          payload: 2
        })
      }

    }
    else {
      const resCreateContact = await Insurance.createContact(
        {
          "icType": formik.values.Step3.soGiayToTuyThan,
          "icNo": formik.values.Step3.soGiayToTuyThan1,
          "fullName": formik.values.Step3.fullName,
          "branchName": null,
          "dateOfBirth": formik.values.Step3.dateOfBirth,
          "gender": formik.values.Step3.gender,
          "phoneNumber": formik.values.Step3.phoneNumber,
          "email": formik.values.Step3.Email,
          "type": "INV",
          "address": formik.values.Step3.getAddressRecevierPers,
          "addresses": [
            {
                "type": "HOME",
                "city": formik.values.Step3.getCityRecevierPers,
                "district": formik.values.Step3.getDistrictRecevierPers,
                "ward": formik.values.Step3.getWardsRecevierPers,
                "detail": formik.values.Step3.getAddressRecevierPers,
            }
        ],
        }
      )
      if(resCreateContact.status ==200)
      {
        console.log(resCreateContact)
        const resUpdate = await Insurance.updateInsurance1({
          "id": formik.values.Step1.id,
          "ownerId": resCreateContact.data.id
        })
        formik.setFieldValue('Step4.contractID', resCreateContact.data.id)
        formik.values.Step4.contractID = resCreateContact.data.id
        const getContact = await Insurance.getContact(resCreateContact.data.id)
        const getContractInfo = await Insurance.getContractInfo(formik.values.Step1.id)
        const getFee = await Insurance.getFee(formik.values.Step1.id)

        if (getContractInfo.status == 200) {
          // console.log(getContractInfo)


          formik.setFieldValue('Step4.contractCode', getContractInfo.data.contractCode);
          formik.setFieldValue('Step4.getFullname', getContractInfo.data.customerName);
          // formik.setFieldValue('Step4.Fee1', (getContractInfo.data.totalFee));
          formik.setFieldValue('Step4.Fee1', (getContractInfo.data.totalFee));

         // formik.setFieldValue('Step4.Fee1', (getContractInfo.data.totalFeeInclVAT));
          formik.setFieldValue('Step4.Fee2', (getContractInfo.data.vatfee));
          // formik.setFieldValue('Step4.Fee3', Utils.formatCurrency(getFee.data[0].totalFee));
          formik.setFieldValue('Step4.Fee3', (getFee.data[0].totalFee));

          formik.setFieldValue('Step4.dateOfBirth', getContractInfo.data.owner.dateOfBirth);
          formik.setFieldValue('Step4.getGender', getContractInfo.data.owner.gender);
          formik.setFieldValue('Step4.getEmail', getContractInfo.data.owner.email);
          formik.setFieldValue('Step4.phoneNumber', getContractInfo.data.owner.phoneNumber);
          formik.setFieldValue('Step4.feeTNDS', (getContractInfo.data.insurances[0].fee));
          formik.setFieldValue('Step4.feeTNDSTNXM', (getContractInfo.data.insurances[1].fee));

         // formik.setFieldValue('Step4.feeTNDS', Utils.formatCurrency(getFee.data[0].MOTOR_TNDS));
         // formik.setFieldValue('Step4.feeTNDSTNXM', (getFee.data[0].MOTOR_CONNGUOI));
          formik.setFieldValue('Step4.getBrand', getContractInfo.data.vehicles[0].manufacturerName);
          formik.setFieldValue('Step4.getFrame', getContractInfo.data.vehicles[0].frameNo);
          formik.setFieldValue('Step4.getMachine', getContractInfo.data.vehicles[0].machineNo);
          formik.setFieldValue('Step4.getTypeVehicle', getContractInfo.data.vehicles[0].vehicleType.name);
          formik.setFieldValue('Step4.getNumberPlate', getContractInfo.data.vehicles[0].numberPlate);
          formik.setFieldValue('Step4.dongXe', getContractInfo.data.vehicles[0].brandName);
          formik.setFieldValue('Step4.getValueDateStart', getContractInfo.data.insurances[0].startValueDate);
          formik.setFieldValue('Step4.getValueDateEnd', getContractInfo.data.insurances[0].endValueDate);

          formik.setFieldValue('Step4.getATMFee', getContractInfo.data.atmPayFee);
          formik.setFieldValue('Step4.getQRFee', getContractInfo.data.qrPayFee);
          formik.setFieldValue('Step4.getFunTransferPayFee', getContractInfo.data.funTransferPayFee);
          formik.setFieldValue('Step4.getShipingFee', getContractInfo.data.shipingFee);

          formik.setFieldValue('Step4.getVisaFee', getContractInfo.data.visaMasterPayFee);

          //  // console.log('hello', getContractInfo.data.vehicles[0].vehicleType.numberPlate)
          formik.setFieldValue();
        }
        dispatch({
          type: ACTION_UPDATE_ACTIVE_STEP,
          payload: 3
        })
      }
      else{
        dispatch({
          type: ACTION_UPDATE_ACTIVE_STEP,
          payload: 2
        })
      }


    }
  }
}
export const getContact = (formik, values) => {
  return async (dispatch) => { }
}
export const payMentType = (formik, values) => {
  return async (dispatch) => {
    const payMentType = await Insurance.payMentType(formik.values.Step1.id, {
      "paymentType": formik.values.Step4.payment,
      "couponCode": null,
      "printedCertType": formik.values.Step4.nhanTuNguoiBan,
      "certNo": formik.values.Step4.SOHDBH

    })
    // console.log(payMentType)
    formik.values.Step5.getPaymentType = formik.values.Step4.payment
    if(payMentType.status == 200)
    {

        if (formik.values.Step4.payment == CONST.PAY_FUND_ATM || formik.values.Step4.payment == CONST.PAY_FUND_QR || formik.values.Step4.payment == CONST.PAY_FUND_GPAY) {
          window.location.replace(payMentType.data.url)
        }
        else {
        //alert(1)
        formik.setFieldValue('Step5.getPaymentType', CONST.PAY_FUND_TRANSFER);
        //formik.setFieldValue('Step5.getPaymentType', formik.values.Step4.payment);
        // formik.values.Step5.getPaymentType = formik.values.Step4.payment
        // // console.log(formik.values)
        const getContractInfo = await Insurance.getContractInfo(formik.values.Step1.id)
        if (getContractInfo.status == 200) {
        if (formik.values.Step3.soGiayToTuyThan == CONST.ID_TYPE_CCCD || formik.values.Step3.soGiayToTuyThan == CONST.ID_TYPE_CCCD || formik.values.Step3.soGiayToTuyThan == CONST.ID_TYPE_HOCHIEU) {
        // // console.log(getContractInfo)
        formik.setFieldValue('Step5.getFullNameOwner', getContractInfo.data.customerName);
        formik.setFieldValue('Step5.getSoGTTTOwner', getContractInfo.data.owner.icNo);
        formik.setFieldValue('Step5.getPhonNumberrOwner', getContractInfo.data.owner.phoneNumber);
        formik.setFieldValue('Step5.getEmailOwner', getContractInfo.data.owner.email);
        formik.setFieldValue("Step5.templateName", Utils.removeVietnameseTones(getContractInfo.data.customerName).replace(" ", "") + '_' + getContractInfo.data.vehicles[0].numberPlate)
        formik.setFieldValue('Step4.contractApprovalId', getContractInfo.data.contractApprovalId);
        }
        else {
        formik.setFieldValue('Step5.getSoGTTTOwner', getContractInfo.data.owner.icNo);
        formik.setFieldValue('Step5.getFullNameOwner', getContractInfo.data.owner.fullName);
        formik.setFieldValue('Step5.getPhonNumberrOwner', getContractInfo.data.owner.phoneNumber);
        formik.setFieldValue('Step5.getEmailOwner', getContractInfo.data.owner.email);
        formik.setFieldValue('Step4.contractApprovalId', getContractInfo.data.contractApprovalId);
        formik.setFieldValue("Step5.templateName", Utils.removeVietnameseTones(getContractInfo.data.customerName).replace(" ", "") + '_' + getContractInfo.data.vehicles[0].numberPlate)
        }
        }
          dispatch({
            type: ACTION_UPDATE_ACTIVE_STEP,
            payload: 4
          })

        }
        formik.values.Step4.contractApprovalId = payMentType.data.id

    }
    else{
      dispatch({
        type: ACTION_UPDATE_ACTIVE_STEP,
        payload: 3
      })

    }

  }
}
export const completeConstract = (formik, values, paymentResult, hmac) => {

  return async (dispatch, getState) => {

      const {insId} = getState().auth.divayUserInfo;
      let isCompllete = false
      let taxInvoiceReceiverId = ''
      let tampOtherOrPers = ''
      let certReceiverId = ""
      if (formik.values.Step5.xuatHoaDonChoNguoiKhac == "OtherPersInvoice") {
        isCompllete = true
        const infos = JSON.stringify({
          icType: formik.values.Step5.loaiGiayto,
          icNo: formik.values.Step5.getMSTTc,
          fullName: formik.values.Step5.getNameTc,
          phoneNumber: formik.values.Step5.getPhoneTc,
          email: formik.values.Step5.getEmailTc,
          address: formik.values.Step5.getAddressTc,
          type: 'INV'
        });
        const resCreateContact = await Insurance.createContact(infos)
        tampOtherOrPers = 'OTHER_INV'
        taxInvoiceReceiverId = resCreateContact.data.id
      }
      else if (formik.values.Step5.xuatHoaDonChoNguoiKhac == "OwnerInvoice" || formik.values.Step5.xuatHoaDonChoNguoiKhac == "NoInvoice") {

        isCompllete = true
        const updateOtherPersInvoice = await Insurance.updateInsurance1
          ({

            "id": formik.values.Step1.id ,//formik.values.Step1.id !="" ? formik.values.Step1.id :formik.values.Step5.getIdContact,
            "icType": formik.values.Step5.loaiGiayto,
            "icNo": formik.values.Step5.soGiayToTuyThan,
            "fullName": formik.values.Step5.name,
            "branchName": null,
            "fullName": formik.values.Step5.name,
            "phoneNumber": formik.values.Step5.phone,
            "email": formik.values.Step5.email,
          })
        tampOtherOrPers = 'OWNER'

        //taxInvoiceReceiverId = formik.values.Step1.id

      }
      else if (formik.values.Step5.xuatHoaDonChoNguoiKhac == "OtherCoprInvoice") {
        isCompllete = true
        const infos = JSON.stringify({
          icType: "MST",
          icNo: formik.values.Step5.getMSTTc,
          fullName: formik.values.Step5.getNameTc,
          phoneNumber: formik.values.Step5.getPhoneTc,
          email: formik.values.Step5.getEmailTc,
          address: formik.values.Step5.getAddressTc,
          type: 'ORG'
        });
        const resCreateContact = await Insurance.createContact(infos)
        tampOtherOrPers = 'OTHER_ORG'
        // // console.log(resCreateContact)
        taxInvoiceReceiverId = resCreateContact.data.id
      }

      if (formik.values.Step5.nhanTuNguoiBan == "DELIVERY") {
        const infos = JSON.stringify({
          fullName: formik.values.Step5.getFullNameRecevierPers,
          phoneNumber: formik.values.Step5.getPhoneNumberRecevierPers,
          address: formik.values.Step5.getAddressRecevierPers,
          addresses: [
            {
              type: "HOME",
              city: formik.values.Step5.getCityRecevierPers,
              district: formik.values.Step5.getDistrictRecevierPers,
              ward: formik.values.Step5.getWardsRecevierPers,
              detail: formik.values.Step5.getAddressRecevierPers,
            }
          ],
          type: 'INV'
        });
        const resCreateContact = await Insurance.createContact(infos)
        // // console.log(resCreateContact)
        if (resCreateContact.status == 200) {
          certReceiverId = resCreateContact.data.id
        }
      }
      if (isCompllete == true) {

        const completeConstract = await Insurance.completeConstract(
          {
            "id":formik.values.Step1.id , //formik.values.Step1.id !="" ? formik.values.Step1.id :formik.values.Step5.getIdContact,
            "taxInvoiceType": tampOtherOrPers, //Otherinv : ca nhan khac,
            "taxInvoiceReceiverId": taxInvoiceReceiverId,
            "certReceiverId": certReceiverId,
            "isSaveTemplate": formik.values.Step5.isSaveTemplate,
            "templateName": formik.values.Step5.templateName
          })
        const completContactUser = await Insurance.approvedConstract(
          [{
            "id": formik.values.Step4.contractApprovalId,//formik.values.Step4.contractApprovalId !="" ? formik.values.Step4.contractApprovalId : formik.values.Step5.contractApprovalId,
            "approvalStatus": "APPROVED",
          }])
        if(completContactUser.status ==200)
        {
          formik.values.Step5.successContractAprovalId =  completContactUser.status
          formik.setFieldValue('Step5.successContractAprovalId', completContactUser.status )
          if (formik.values.Step5.finishAction != "BUYNEW") {
            if (paymentResult === 'COMPLETE') {
              window.location.href = `${BaseAppConfigs.DIVAY_URL}/#/insurances/call-back?insId=${insId}&status=SUCCESS&hmac=${hmac}`
            } else {
              window.location.href = BaseAppConfigs.DIVAY_URL;
            }
          }
          else {
            window.location.reload()
            history.push("/buy-insurance/motor")
            formik.resetForm()


          }
}
        else{
          dispatch({
            type: ACTION_UPDATE_ACTIVE_STEP,
            payload: 4
          })
        }

      }


  }
}
//NONE khong nhan , OWNER  chu so huu, OTHER_INV ca nhan khac, OTHER_ORG  to chuc khac
